import { t } from "i18next"
import { Typography, palette } from "@callcenter/design-system"

import { useAccountInfo } from "./account-information.hooks"

import mainStyles from "../../shared/styles.module.pcss"
import styles from "./account-information.module.pcss"

export const AccountInformation = () => {
  const accountInfo = useAccountInfo()

  return (
    <div className={mainStyles.accountInfoBlockWrapper}>
      <Typography.Body1>
        {t("userProfile_userProfileSidePanel_sectionHeading_accountInformationHeadLabel")}
      </Typography.Body1>
      <div>
        {accountInfo.map((info) => (
          <div key={info.label} className={mainStyles.accountInfoLine}>
            <Typography.Body2 color={palette.gray8}>{info.label}</Typography.Body2>
            <Typography.Body2 className={styles.accountInfoValueContainer}>{info.value}</Typography.Body2>
          </div>
        ))}
      </div>
    </div>
  )
}
